const backgrounds = [
    "1.jpg",
    "2.jpg",
    "3.jpg",
    "4.jpg",
    "5.jpg",
    "6.jpg",
    "7.jpg",
    "8.jpg",
    "9.jpg"
];

function setLoginBackgroundImage(){
    let bg = backgrounds[Math.floor(Math.random() * backgrounds.length)];
    $("#kt_login").css('background-image', `url('/assets/media/bg/${bg}')`);
}

setLoginBackgroundImage();